<template>
  <v-container fluid class="d-flex align-center justify-center">
    <v-row justify="center" align="center" class="fill-height">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-card class="pa-6" elevation="8" rounded="xl">
          <div class="text-center mb-4">
            <h2 class="font-weight-bold mb-1">
              {{ $t("labels.WelcomeBack") }}
            </h2>
            <p class="grey--text">Login to continue to your dashboard</p>
          </div>

          <!-- Google Login -->
          <!-- <div class="text-center mb-4">
            <GoogleLogin @response="checkResponse" />
          </div> -->

          <!-- <v-divider class="my-4">
            <span class="grey--text">{{ $t("labels.or") }}</span>
          </v-divider> -->

          <!-- Email -->
          <v-text-field
            v-model="email"
            outlined
            color="primary"
            label="Email"
            :error-messages="emailErrors"
            class="mb-3"
          />

          <!-- Password -->
          <v-text-field
            v-model="password"
            outlined
            color="primary"
            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            :type="showPassword ? 'text' : 'password'"
            :label="$t('labels.password')"
            :error-messages="passwordErrors"
            counter
            @keyup.enter.prevent="submit"
            @click:append="showPassword = !showPassword"
          />

          <!-- Login Button -->
          <v-btn
            block
            color="primary"
            large
            class="mt-4 v-btn-with-radius"
            data-cy="loginSubmitBtn"
            @click.stop="submit"
          >
            Login
          </v-btn>

          <!-- Forgot Password -->
          <div class="text-center mt-3">
            <router-link
              data-cy="loginForgotPassword"
              to="/forgotPassword"
              style="text-decoration: none; color: #3677ff"
            >
              Forgot Password?
            </router-link>
          </div>

          <!-- Divider -->
          <v-divider class="my-6"></v-divider>

          <!-- Sign Up Redirect -->
          <div class="text-center">
            <span>Don't have an account?</span>
            <v-btn text color="pink" class="ml-1" @click="signUp">
              Sign up
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import authService from "../service";
import GoogleLogin from "./GoogleLogin";

const { validationMixin } = require("vuelidate");
const { required, email } = require("vuelidate/lib/validators");

export default {
  name: "authentication-login",
  components: { GoogleLogin },
  data() {
    return {
      showPassword: false,
      email: null,
      password: null,
    };
  },
  async created() {
    localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
  },
  methods: {
    ...mapActions("global", ["initOrganization"]),
    signUp() {
      this.$router.push({ path: "/signup" });
    },
    submit() {
      this.$v.$touch();
      if (this.email) this.email = this.email.toLowerCase();
      if (this.$v.$invalid) {
        this.$toasted.error("Invalid Input", {
          position: "top-right",
          showHideTransition: "slide",
          duration: 2000,
        });
        return;
      }
      this.$Progress.start();
      return authService
        .authenticate({ email: this.email, password: this.password })
        .then((response) => {
          this.$Progress.finish();
          this.checkResponse(response);
        })
        .catch((error) => {
          this.$Progress.finish();
          console.error(error);
          this.$swal("Invalid Login");
        });
    },
    checkResponse(response) {
      if (
        response.data &&
        response.data.user &&
        response.data.user.Organizations.length === 1
      ) {
        return this.initOrganization(response.data.user.Organizations[0]).then(
          () => this.$router.push({ path: "/" })
        );
      }
      if (
        response.data &&
        response.data.user &&
        response.data.user.Organizations.length > 1
      ) {
        this.$router.push({
          path: "/login/organization",
          name: "authentication-select-organization",
          params: { Organizations: response.data.user.Organizations },
        });
      } else if (response.data && response.data.user) {
        this.$router.push({ path: "/newOrganization" });
      } else {
        this.$toasted.error("Invalid Login Request", {
          position: "top-right",
          showHideTransition: "slide",
          duration: 2000,
        });
      }
    },
  },
  computed: {
    ...mapGetters("brand", ["currentBrand", "brandConfig"]),
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      if (!this.$v.email.email) errors.push("Email is not valid");
      if (!this.$v.email.required) errors.push("Email is required");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      if (!this.$v.password.required) errors.push("Password is required");
      return errors;
    },
  },
  mixins: [validationMixin],
  validations: {
    email: { email, required },
    password: { required },
  },
};
</script>